import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ChangeStatusButton } from 'backoffice/payments/_components';
import { withTheme } from 'common/styling/theme';
import { StatusCell, DateCell } from 'common/components';

import { staticStyles, getDynamicStyles } from './style';

const TransferCommonDetails = ({
  id,
  from,
  to,
  sendAmount,
  status,
  manager,
  transferType,
  created,
  hasPaymentOperationManagers,
  profile,
  theme,
}) => {
  const TRANSFER_TYPE_SLUGS = {
    INNER: 'boInnerTransfer',
    TO_TRADER: 'boAnotherTrader',
    FROM_WALLET: 'fromWallet',
    FROM_WALLET_ACCOUNT: 'fromWalletAccount',
    TO_WALLET_ACCOUNT: 'toWalletAccount',
    TO_WALLET: 'toWallet',
    TO_TRADER_WALLET_ACCOUNT: 'toTraderWalletAccount',
    TO_TRADER_WALLET: 'toTraderWallet',
    TO_TRADER_LPA: 'justToLpa',
    TO_TRADER_WALLET_LPA: 'justToWalletLpa',
    INVEST_INNER: 'justInvestInner',
    TO_WALLET_INVEST: 'justToWalletInvest',
    FROM_WALLET_INVEST: 'justFromWalletInvest',
    FROM_WALLET_ACCOUNT_INVEST: 'justFromWalletAccountInvest',
    TO_WALLET_ACCOUNT_INVEST: 'justToWalletAccountInvest',
    INVEST_REWARD: 'justInvestReward',
  };

  const dynamicStyles = Object.keys(theme).length ? getDynamicStyles(theme) : ` `;

  return (
    <div className="TransferCommonDetails">
      <ul>
        <li>
          <FormattedMessage id="justID" />
          {id}
        </li>
        <li>
          <FormattedMessage id="accountFrom" />
          {from || <FormattedMessage id="menuWallet" />}
        </li>
        <li>
          <FormattedMessage id="accountTo" />
          {to || <FormattedMessage id="menuWallet" />}
        </li>
        <li>
          <FormattedMessage id="boStatus" />
          <StatusCell statusCode={status} />
        </li>
        {sendAmount.amount && sendAmount.currency && (
          <li>
            <FormattedMessage id="boAmount" />
            {sendAmount.amount} {sendAmount.currency}
          </li>
        )}
        {hasPaymentOperationManagers && (
          <li>
            <FormattedMessage id="justManager" />
            {manager ? `${manager?.firstName} ${manager?.lastName}` : '一'}
          </li>
        )}
        <li>
          <FormattedMessage id="boTransferType" />
          {TRANSFER_TYPE_SLUGS[transferType] ? <FormattedMessage id={TRANSFER_TYPE_SLUGS[transferType]} /> : '一'}
        </li>
        {created && (
          <li>
            <FormattedMessage id="boCreated" />
            <DateCell value={created} />
          </li>
        )}
      </ul>
      {(profile?.isAdmin || profile?.perms?.superUserPerm) && (
        <div className="TransferCommonDetails__change-status-wrapper">
          <ChangeStatusButton type="transfer" requestId={id} />
        </div>
      )}
      <style jsx global>
        {staticStyles}
      </style>
      <style jsx global>
        {dynamicStyles}
      </style>
    </div>
  );
};

TransferCommonDetails.propTypes = {
  id: PropTypes.number.isRequired,
  status: PropTypes.string.isRequired,
  profile: PropTypes.object.isRequired,
  theme: PropTypes.object,
  sendAmount: PropTypes.object,
  from: PropTypes.string,
  to: PropTypes.string,
  manager: PropTypes.string,
  transferType: PropTypes.string,
  created: PropTypes.string,
  hasPaymentOperationManagers: PropTypes.bool,
};

TransferCommonDetails.defaultProps = {
  from: '',
  to: '',
  manager: '',
  transferType: '',
  created: '',
  hasPaymentOperationManagers: false,
  theme: {},
  sendAmount: {},
};

export default compose(
  withTheme(),
  connect(state => ({
    profile: state.user.profile,
    hasPaymentOperationManagers: state.interfaceConfig.features.includes('paymentOperationManager'),
  }))
)(TransferCommonDetails);
export { TransferCommonDetails };
